import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTranslation } from 'react-i18next';

const SkipGroup = ({ titleKey, items }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  if (!items || items.length === 0) return null;
  return (
    <Box sx={{ mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton size="small" onClick={() => setOpen(!open)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {t(titleKey, { count: items.length })}
        </Typography>
      </Box>
      <Collapse in={open}>
        <List dense disablePadding sx={{ pl: 4 }}>
          {items.map((it) => (
            <ListItem key={it.id} disablePadding>
              <ListItemText primary={it.displayName} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  );
};

const SkippedInventoriesAlert = ({ skippedInventories }) => {
  const { t } = useTranslation();
  if (!skippedInventories || skippedInventories.length === 0) return null;

  const empty = skippedInventories.filter((s) => s.reason === 'WOULD_LEAVE_NO_CONTACTS');
  const noPerm = skippedInventories.filter((s) => s.reason === 'NO_PERMISSION');

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>{t('batch.update.contacts.skip.panel.header')}</AlertTitle>
      <SkipGroup titleKey="batch.update.contacts.skip.reason.empty.group" items={empty} />
      <SkipGroup titleKey="batch.update.contacts.skip.reason.no.permission.group" items={noPerm} />
    </Alert>
  );
};

export default SkippedInventoriesAlert;
